import directives from './module';

interface SearchTextOnChangesObject extends ng.IOnChangesObject {
    searchText: ng.IChangesObject<string>;
    searchElement: ng.IChangesObject<string>;
}

class SearchText implements ng.IComponentController {
    searchText: string;
    searchElement: string;

    private elements: NodeListOf<HTMLElement>;
    private hideClassName = 'ng-hide';

    constructor(private $element: ng.IAugmentedJQuery) {
    }

    $onChanges(onChangesObj: SearchTextOnChangesObject) {
        if (onChangesObj.searchText.isFirstChange()) return;
        const el        = this.$element[0];
        this.searchText = this.searchText.toLocaleLowerCase();

        if (this.searchElement) {
            this.elements    = el.querySelectorAll(this.searchElement);
            const isElements = !!_.filter(this.elements, (el: HTMLElement) => this.check(el)).length;
            this.hideEl(el, !isElements);
        } else {
            this.check(el);
        }
    }

    private check(el: HTMLElement): boolean {
        const text    = el.innerText.toLocaleLowerCase();
        const matched = !this.searchText || text.includes(this.searchText);
        this.hideEl(el, !matched);
        return matched;
    }

    private hideEl(el: HTMLElement, isHide: boolean) {
        if (isHide) {
            el.classList.add(this.hideClassName);
        } else {
            el.classList.remove(this.hideClassName);
        }
    }
}

directives.directive('searchText', (): ng.IDirective => ({
    restrict: 'A',
    bindToController: {
        searchText: '<',
        searchElement: '@?'
    },
    controller: SearchText
}));



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/SearchText.ts